import { DateTime } from 'luxon';
import { useState } from 'react';
import { useGetFundRates } from '../../../../api/funds-robot/getFundRates';
import { Bond } from '../../../../types/Bond';
import { Stock } from '../../../../types/Stock';
import { downloadCSV, getSelectableYears, ratesAndDividendToNAVCSVString } from '../../../../utils/functions';
import { ModalScreenFunds } from '../../../general/ModalScreen';
import { NavDailyRates } from '../nav-overlay-tables/NavDailyRates';
import { OverlayTableHeader } from '../nav-overlay-tables/OverlayTableHeader';

export const NAVModal: React.FC<{ fund: Stock | Bond; isShown: boolean; onClose: () => void }> = ({
    fund,
    isShown,
    onClose,
}) => {
    const [year, setYear] = useState(DateTime.now().year);

    const fundRates = useGetFundRates(fund?.id, DateTime.now(), DateTime.now().minus({ year: 10 }));

    const selectableYears = getSelectableYears(fundRates.data);

    return (
        <ModalScreenFunds isShown={isShown}>
            <div id="nav-modal" className="bg-gray-100">
                <OverlayTableHeader
                    title="NAV dagkoers"
                    selectionYears={selectableYears}
                    onClose={onClose}
                    selectedYear={year}
                    onYearSelected={setYear}
                    onExportCSV={() => {
                        downloadCSV(
                            fund.name + ' koersen.csv',
                            ratesAndDividendToNAVCSVString(fundRates.data?.rates || [], fund?.dividendPayments || []),
                        );
                    }}
                />
                <NavDailyRates className="p-6" selectedYear={year} asset={fund} />
            </div>
        </ModalScreenFunds>
    );
};
